import { useTenantAddons, TenantAddonConstants } from '../../components/tenant-addons';

function isTrue(value: string | undefined): boolean {
  return value?.trim().toLocaleLowerCase() === 'true';
}

export interface AiAssistantAvailability {
  enabled: boolean;
  restrictedToAdminPage: boolean;
}

export function useAiAssistantAvailability() {
  const { isTenantAddonEnabled, getAddonConfiguration } = useTenantAddons();

  function isRestrictedToAdminPage(configurationName: string): boolean {
    const configuredValue = getAddonConfiguration(configurationName);
    // Fail closed: an unavailable configuration (not yet loaded or request failed) must not expose the assistant
    if (configuredValue === undefined) {
      return true;
    }
    return isTrue(configuredValue);
  }

  const aiFasitAssistant = {
    enabled: isTenantAddonEnabled([TenantAddonConstants.Lexi]),
    restrictedToAdminPage: isRestrictedToAdminPage('AiFasitAssistantAdminOnly'),
  } satisfies AiAssistantAvailability;

  const aiCitizenAssistant = {
    enabled: isTenantAddonEnabled([TenantAddonConstants.Summa]),
    restrictedToAdminPage: isRestrictedToAdminPage('AiCitizenAssistantAdminOnly'),
  } satisfies AiAssistantAvailability;

  return { aiFasitAssistant, aiCitizenAssistant };
}
